const sameWidth = {
  name: 'sameWidth',
  enabled: true,
  phase: 'beforeWrite',
  requires: ['computeStyles'],
  fn({ state, ...other }) {
    const width = state.elements.reference.clientWidth
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
    state.styles.popper.maxWidth = `${Math.max(width, 280)}px`
    state.styles.popper.boxSizing = 'border-box'
    state.styles.popper.minWidth = vw <= 420 ? width : `${Math.max(width * (2 / 3), 220)}px`
    return { ...state, styles: state.styles }
  }
}

export { sameWidth }